/**
 * @generated SignedSource<<dc2e648e952201720285f3c847df228a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventsPageSectionsFragment$data = {
  readonly active: {
    readonly totalCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"EventsCarouselFragment">;
  };
  readonly closed: {
    readonly totalCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"EventsCarouselFragment">;
  };
  readonly tutorial: {
    readonly totalCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"EventsCarouselFragment">;
  };
  readonly upcoming: {
    readonly totalCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"EventsCarouselFragment">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"TrackOfTheMonthFragment">;
  readonly " $fragmentType": "EventsPageSectionsFragment";
};
export type EventsPageSectionsFragment$key = {
  readonly " $data"?: EventsPageSectionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventsPageSectionsFragment">;
};

import EventsPageSectionsFragmentPaginationQuery_graphql from './EventsPageSectionsFragmentPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "cursor"
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  },
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "EventsCarouselFragment"
  }
],
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "count"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "activeFilters"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "closedFilters"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "tutorialFilters"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "upcomingFilters"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": EventsPageSectionsFragmentPaginationQuery_graphql
    }
  },
  "name": "EventsPageSectionsFragment",
  "selections": [
    {
      "alias": "tutorial",
      "args": [
        (v0/*:: as any*/),
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "tutorialFilters"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 3
        }
      ],
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": "upcoming",
      "args": [
        (v0/*:: as any*/),
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "upcomingFilters"
        },
        (v2/*:: as any*/)
      ],
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": "active",
      "args": [
        (v0/*:: as any*/),
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "activeFilters"
        },
        (v2/*:: as any*/)
      ],
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": "closed",
      "args": [
        (v0/*:: as any*/),
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "closedFilters"
        },
        (v2/*:: as any*/)
      ],
      "concreteType": "EventConnection",
      "kind": "LinkedField",
      "name": "events",
      "plural": false,
      "selections": (v1/*:: as any*/),
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TrackOfTheMonthFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "1a0c4887acec27d2ca7a90b233c60d06";

export default node;
